exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:1024px){.text-container[data-v-9266dab2]{max-width:300px}}", ""]);

// exports
